import styled from "styled-components";
import { FC } from "react";

import Text from "@/components/Text";

const Block = styled.div`
  height: 36px;
  padding: 0 8px 0 12px;
  background: ${({ theme }) => theme.colors.grayscaleLight};
  border-radius: 4px;
  width: 132px;
  color: ${({ theme }) => theme.colors.gray};
  display: flex;
  align-items: center;
`;

const DownloadButton = styled.a`
  width: 24px;
  height: 24px;
  background: ${({ theme }) => theme.colors.lightGray};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color ease-out 0.2s;
  color: ${({ theme }) => theme.colors.black};
  margin-left: auto;
  &:hover {
    color: ${({ theme }) => theme.colors.gray};
  }
`;

const StyledText = styled(Text)`
  margin-left: 8px;
`;

interface Props {
  fileUrl: string;
}

const EytvFilesBlock: FC<Props> = ({ fileUrl }) => {
  return (
    <Block>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.2073 14.7694H1.84683C1.68362 14.7694 1.52709 14.7046 1.41169 14.5892C1.29628 14.4738 1.23145 14.3172 1.23145 14.154V1.84634C1.23145 1.68313 1.29628 1.52661 1.41169 1.4112C1.52709 1.29579 1.68362 1.23096 1.84683 1.23096H14.1545C14.3177 1.23096 14.4743 1.29579 14.5897 1.4112C14.7051 1.52661 14.7699 1.68313 14.7699 1.84634V10.2068C14.7699 10.2876 14.754 10.3677 14.7231 10.4423C14.6921 10.517 14.6468 10.5848 14.5897 10.642L10.6425 14.5892C10.5853 14.6463 10.5175 14.6916 10.4428 14.7226C10.3681 14.7535 10.2881 14.7694 10.2073 14.7694V14.7694Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7141 10.4609H10.4619V14.7137"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <StyledText $type="smallNormal">CSV file</StyledText>
      <DownloadButton href={fileUrl} download>
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 6.78571L6 10.7857L10 6.78571"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 1.64285V10.7857"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </DownloadButton>
    </Block>
  );
};

export default EytvFilesBlock;
